import { render, staticRenderFns } from "./TableOnePlusTwoEl.vue?vue&type=template&id=a0a2e8a8&scoped=true&"
import script from "./TableOnePlusTwoEl.vue?vue&type=script&lang=ts&"
export * from "./TableOnePlusTwoEl.vue?vue&type=script&lang=ts&"
import style0 from "./TableOnePlusTwoEl.vue?vue&type=style&index=0&id=a0a2e8a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a2e8a8",
  null
  
)

export default component.exports